/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';

export const useIsElementVisible = (ref, options = undefined) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const target = ref?.current;
    if (!target) {
      return;
    }

    const handleVisibilityChange = ([entry]) => {
      setIsVisible(entry.isIntersecting);
    };

    const observer = new IntersectionObserver(handleVisibilityChange, options);
    observer.observe(target);
    return () => {
      if (target) observer.unobserve(target);
    };
  }, [ref?.current, options]);

  return isVisible;
};
